import localStorage from '../../local-storage';
import Config from '../../config';

// This one is async since the native one is, so this call is always awaited
// in api-fetch/appendJWTToken
const getAuthToken = async () => {
  const token = localStorage.getItem(Config.LOCAL_STORAGE_AUTH_KEY);
  return token;
};

export default getAuthToken;
